import {mergeDeep} from "../utils";
import Base, {clearLeg, isSeriesCompleted} from "./base";

class Game extends Base {
  constructor(ctx, data, urls = window.URLS, type_game = 'score') {
    super(ctx, data, urls)

    if (type_game === this.get('game').type_game) {
      this.set('game', mergeDeep({
        data: [[]],
      }, this.get('game')))
      this.restoreSelected()
    }
  }

  get maxSeries() {
    const leg = this.data;
    const max_series = this.getMaxSeriesBySettings(leg)
    return leg.length > max_series ? leg.length : max_series
  }

  isDraw(leg) {
    const [score_1, score_2] = this.calculateScore(leg)
    const isComplete = this.isComplete(leg)
    return isComplete && score_1 === score_2
  }

  offsetSectors() {
    return 0
  }

  validateScore(score) {
    return score <= 180;
  }

  isComplete(leg) {
    const max_series = this.getMaxSeriesBySettings(leg)
    return leg.length >= max_series && leg.every((ss) => isSeriesCompleted(ss, this.advanced_input))
  }

  getWinnerNumberByLeg(leg) {
    const [score_1, score_2] = this.calculateScore(leg)
    const isComplete = this.isComplete(leg)
    if (!isComplete) return
    if (score_1 !== score_2) {
      if (score_1 > score_2) {
        return 1
      }
      if (score_2 > score_1) {
        return 2
      }
    } else {
      if (leg[leg.length - 1][0]?.winner) {
        return 1
      }
      if (leg[leg.length - 1][1]?.winner) {
        return 2
      }
      return 0
    }
  }

  getDataAndScore(ss) {
    const legs = this.get('game').data
    const [i, p] = this.get('selected');
    const leg = legs.at(-1)
    const series = leg.at(i) || [{}, {}]
    series[p] = ss
    leg[i] = series
    legs[legs.length - 1] = clearLeg(leg)
    return [legs, this.calculateTotalScore(legs)]
  }

  getLastPosition() {
    const leg = this.data;
    return [leg.length - 1, +!this.first]
  }

  getPriorityHits() {
    return this.getPriorityBaseHits()
  }

  /* score */

  getMaxSeriesBySettings() {
    const {settings} = this.get('game')
    return settings.max_series || 10
  }

  calculateScoreRound(leg) {
    return leg.reduce((scores, series) => {
      if (isSeriesCompleted(series, this.advanced_input)) {
        if (series[0].score > series[1].score) {
          scores[0] += 1
        } else if (series[0].score < series[1].score) {
          scores[1] += 1
        }
      }
      return scores
    }, [0, 0])
  }


  completedLeg(leg) {
    const max_series = this.getMaxSeriesBySettings(leg)
    const [score_1, score_2] = this.calculateScore(leg)
    return score_1 !== score_2 && leg.length >= max_series && leg.every((ss) => isSeriesCompleted(ss, this.advanced_input))
  }
}

export default Game